import axios from "axios";
import { supabase } from "@/lib/supabase";

// Same shape as landing/src/lib/scanner.js and extension/src/lib/config.ts: the
// canonical host is the default and a build variable overrides it. Without the
// default a dashboard built with REACT_APP_BACKEND_URL unset requested
// "undefined/api/v1", which fails as a bare network error with nothing naming
// the cause. The trailing slash is trimmed because the value is documented as
// having none and a stray one produced "//api/v1".
export const API_ORIGIN = (
  process.env.REACT_APP_BACKEND_URL || "https://api.complaudax.com"
).replace(/\/+$/, "");

export const api = axios.create({
  baseURL: `${API_ORIGIN}/api/v1`,
});

api.interceptors.request.use(async (config) => {
  const { data } = await supabase.auth.getSession();
  if (data?.session?.access_token) {
    config.headers.Authorization = `Bearer ${data.session.access_token}`;
  }
  return config;
});

// Axios gives every request that got no response at all the same message,
// "Network error", and the pages render it verbatim. A connect-src the CSP does
// not cover, a host that does not resolve and an API that is down are three
// very different problems that all read identically. Naming the origin is what
// separates them without opening the console.
api.interceptors.response.use(undefined, (error) => {
  if (!error.response) {
    error.message = `Could not reach the API at ${API_ORIGIN} (${error.message}).`;
  }
  return Promise.reject(error);
});
